import React from 'react';
import ReactDOM from 'react-dom';
import Collapsible from 'react-collapsible';

class CollapseMenu extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

    return(

      <Collapsible trigger="Jump to...">
				<div className="disc jumpto js-list">
					<div dangerouslySetInnerHTML={{ __html: this.props.content }} />
				</div>
      </Collapsible>

    );
  }

}

document.addEventListener('DOMContentLoaded', () => {

	var jump_list = document.querySelectorAll('.jumpto__list'); // returns NodeList
	var jump = [...jump_list]; // converts NodeList to Array

	jump.forEach(collapsible => {

		let content = collapsible.innerHTML;

		ReactDOM.render(
			<CollapseMenu content={content} />,
			collapsible,
		)
	});
})
